<template>
  <div class="home">
    <div style="margin-top:-5px;width:1000px;">
      <el-link v-for="page in pageList" :key="`url${page.id}`" type="primary" style="margin-right:15px;" :href="`./#/${page.id}`"
        target="_blank">{{
          page.name }}</el-link>
    </div>

    <el-card class="box-card" v-for="(item, key) in cardList" :key="key" @keyup.enter.native="keyboardMove"
      :style="'border:1px solid ' + item.bordercolor + ';width:' + item.width + 'px;height:' + item.height + 'px;left:' + item.xoffset + 'px;top:' + item.yoffset + 'px'">
      <div slot="header" class="clearfix">
        <span class="title bold" @click="showMove(key)">{{ item.title }} </span>
        <span @click="showMove(key)" v-if="!isNaN(item.average)"
          :class="{ 'red': Number(item.average) > 0, 'green': Number(item.average) < 0, 'bold': Math.abs(Number(item.average)) > 2 }">{{
            Math.round(item.average * 100, 2) / 100
          }}</span>
        <el-button class="btn-top" type="text" @click="refreshCard(key,'change')">刷</el-button>
        <span></span><!--elementUI有个隐藏css：两个相邻按钮会自动添加间隔（el-button+el-button{margin-left:10px;}。屏蔽的方法：在两个按钮之间添加一个空的span。-->
        <el-button class="btn-top" type="text" @click="jumpChart(key)" icon="el-icon-link"></el-button>
        <!-- <el-button class="btn-top" type="text" @click="sortValue(key)" icon="el-icon-sort"></el-button> -->
        <span></span><!--elementUI有个隐藏css：两个相邻按钮会自动添加间隔（el-button+el-button{margin-left:10px;}。屏蔽的方法：在两个按钮之间添加一个空的span。-->
        <el-button v-if="item.type == 3 || item.type == 4" class="btn-top" type="text"
          @click="addStock(key)" icon="el-icon-plus"></el-button>
        <span></span><!--elementUI有个隐藏css：两个相邻按钮会自动添加间隔（el-button+el-button{margin-left:10px;}。屏蔽的方法：在两个按钮之间添加一个空的span。-->
        <el-button v-if="item.type == 5" class="btn-top" type="text"
          @click="getStockListFromIwencai(key)" icon="el-icon-magic-stick"></el-button>
        <span></span><!--elementUI有个隐藏css：两个相邻按钮会自动添加间隔（el-button+el-button{margin-left:10px;}。屏蔽的方法：在两个按钮之间添加一个空的span。-->
        <el-button v-if="item.xoffset == 0 || item.xoffset == 2750 || item.xoffset == 5500 || item.xoffset == 8000"
          class="btn-top" type="text" @click="refreshAll(key)">刷10</el-button>
        <span></span><!--elementUI有个隐藏css：两个相邻按钮会自动添加间隔（el-button+el-button{margin-left:10px;}。屏蔽的方法：在两个按钮之间添加一个空的span。-->
        <el-button v-if="item.type == 5 && (item.xoffset == 500 || item.xoffset == 3250 || item.xoffset == 6000 || item.xoffset == 8500)"
          class="btn-top" type="text" @click="getStockListFromIwencaiAll(key)">批</el-button>
        <span></span><!--elementUI有个隐藏css：两个相邻按钮会自动添加间隔（el-button+el-button{margin-left:10px;}。屏蔽的方法：在两个按钮之间添加一个空的span。-->
        <el-button v-if="item.xoffset == 250 && item.yoffset == 510" class="btn-top" type="text"
          @click="showSetting = true" icon="el-icon-setting"></el-button>
        <span></span><!--elementUI有个隐藏css：两个相邻按钮会自动添加间隔（el-button+el-button{margin-left:10px;}。屏蔽的方法：在两个按钮之间添加一个空的span。-->
        <el-button v-if="item.title_text == '连板'" class="btn-top" type="text"
          @click="setLianBanNewest">最新</el-button>
      </div>
      <div class="card-content">
        <div v-for="(v, k) in item.datalist_arr" :key="k" class="text item">
          <span v-for="(x, y) in item.fieldlist_arr" :key="y" @click="info(key, v.market, v.code)" :title="v.desc">
            <span v-if="x != 'code'"><!--不再显示code-->
              <span v-if="x == 'name'" style="width: 72px; display: inline-block;"> {{ v[x] }}
              </span><!--给股票名称设置固定宽度，对齐显示-->
              <span v-else-if="x == 'changeRank' && (item.type == 4 || item.type == 5)"
                :class="{ 'red': Number(v.changeRankValue) > 0, 'green': Number(v.changeRankValue) < 0 , 'gray': v.changeRankValue == '0' }"
                style="width: 27px; display: inline-block;"> {{ v[x] }}
              </span><!--给股票名称设置固定宽度，对齐显示-->
              <span v-else> {{ v[x] }} </span>
            </span>
          </span>
          <span style="width: 38px; display: inline-block; margin-right: 5px; text-align: right;"
            @click="info(key, v.market, v.code)">
            <span v-if="v.isIndex == true"
              :class="{ 'red': Number(v.value) > 0, 'green': Number(v.value) < 0, 'red-bg': Number(v.value) > indexValueRank2, 'green-bg': Number(v.value) < 0 - indexValueRank2, 'bold': Math.abs(Number(v.value)) > indexValueRank1 }">
              {{ v.value }}</span>
            <span v-else
              :class="{ 'red': Number(v.value) > 0, 'green': Number(v.value) < 0, 'red-bg': Number(v.value) > stockValueRank2, 'green-bg': Number(v.value) < 0 - stockValueRank2, 'bold': Math.abs(Number(v.value)) > stockValueRank1 }">
              {{ v.value }}</span>
          </span>
          <span style="width: 38px; display: inline-block; margin-right: 5px; text-align: right; opacity: 0.6;"
            @click="info(key, v.market, v.code)">
            <span v-if="v.isIndex == true"
              :class="{ 'red': Number(v.speed) > 0, 'green': Number(v.speed) < 0, 'red-border': Number(v.speed) > indexSpeedRank1, 'green-border': Number(v.speed) < 0 - indexSpeedRank1, 'bold-border bold': Math.abs(Number(v.speed)) > indexSpeedRank2 }">
              {{ v.speed }}</span>
            <span v-else
              :class="{ 'red': Number(v.speed) > 0, 'green': Number(v.speed) < 0, 'red-border': Number(v.speed) > stockSpeedRank1, 'green-border': Number(v.speed) < 0 - stockSpeedRank1, 'bold-border bold': Math.abs(Number(v.speed)) > stockSpeedRank2 }">
              {{ v.speed }}</span>
          </span>
        </div>
        <el-button v-if="item.type == 3 || item.type == 4 || item.type == 5" type="text"
          @click="editDatalist(key)">添加/删除</el-button>
          
        <el-link v-if="item.iwencai != '' && item.iwencai != null" type="primary" style="margin-top: -2px; margin-left: 10px;" :href="apiUrl.iwencai+item.iwencai" target="_blank">问财</el-link>
      </div>
    </el-card>

    <el-dialog :visible.sync="showChartDialog" width="725px" top="1vh">
      <el-row>
        <el-col :span="19">
          <el-image :style="baseSetting.chartStyle[globalSetting.chartSource].chartK" :src="chartK"></el-image>
          <el-image :style="baseSetting.chartStyle[globalSetting.chartSource].chartMin" :src="chartMin"></el-image>
        </el-col>
        <el-col :span="5">
          <el-row>
            <el-link type="primary" style="margin-top: -3px; margin-right: 10px;" :href="F10ThsUrl" target="_blank"
              icon="el-icon-link">
              同花顺F10</el-link>
            <el-link type="primary" style="margin-top: -3px; margin-right: 10px;" :href="F10EmUrl" target="_blank"
              icon="el-icon-link">
              东财F10</el-link>
            <el-link type="primary" style="margin-top: -3px; margin-right: 10px;" :href="moneyNetValueEmUrl"
              target="_blank" icon="el-icon-link">
              资金流向</el-link>
            <el-button type="text" @click="doShowMoneyChart" icon="el-icon-alarm-clock">含韭量</el-button>
            <br />
            <el-button type="text" @click="lastOne" icon="el-icon-top">上一个</el-button>
            <br />
            <el-button type="text" @click="nextOne" icon="el-icon-bottom">下一个</el-button>
            <br />
            <el-button type="text" @click="copyCode" icon="el-icon-copy-document">复制代码</el-button>
          </el-row>
          <el-row v-for="(a, b) in plateList" :key="b">
            <el-tooltip class="item" effect="dark" :content="a.reason" placement="bottom">
              <el-link type="info"><span
                  :class="{ 'red': Number(a.core_avg_pcp) > 0, 'green': Number(a.core_avg_pcp) < 0, 'bold': Math.abs(Number(a.core_avg_pcp)) > 2 }">{{
                    Math.round(a.core_avg_pcp * 1000, 2) / 10
                  }}</span> {{ a.plate_name }}</el-link>
            </el-tooltip>
          </el-row>
        </el-col>
      </el-row>
    </el-dialog>

    <el-dialog :visible.sync="showMoveDialog" width="500px" :show-close="false" top="1vh">
      <el-form label-width="60px">
        <el-form-item label="">
          <el-button type="primary" size="mini" @click="move('yoffset', -500)" style="font-size:20px;">↑</el-button>
          <el-button type="primary" size="mini" @click="move('xoffset', 250)" style="font-size:20px;">→</el-button>
          <el-button type="primary" size="mini" @click="move('yoffset', 500)" style="font-size:20px;">↓</el-button>
          <el-button type="primary" size="mini" @click="move('xoffset', -250)" style="font-size:20px;">←</el-button>
        </el-form-item>
        <el-form-item label="页面">
          <el-select v-model="model.page_id" placeholder="请选择2">
            <el-option v-for="page in pageList" :key="page.id" :label="page.name" :value="page.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="类型">
          <el-input v-model="model.type"
            placeholder="1：aktools；2：xlshare；3：股票code列表；4：股票code列表且记录与右侧card排名变化；5：股票code列表且记录与下方card排名变化"></el-input>
        </el-form-item>
        <el-form-item label="标题">
          <el-input v-model="model.title"></el-input>
        </el-form-item>
        <el-form-item label="请求源">
          <el-input v-model="model.url" placeholder="type为1、2时适用"></el-input>
        </el-form-item>
        <el-form-item label="票票们">
          <el-input v-model="model.datalist" placeholder="type为3、4、5时适用，6位股票代码，英文逗号分隔"></el-input>
        </el-form-item>
        <el-form-item label="列映射">
          <el-input v-model="model.fieldmap" placeholder="示例：代码%%code,名称%%name"></el-input>
        </el-form-item>
        <el-form-item label="显示列">
          <el-input v-model="model.fieldlist" placeholder="示例：code,name"></el-input>
        </el-form-item>
        <el-form-item label="问财语">
          <el-input v-model="model.iwencai" placeholder="示例：今成交额前100"></el-input>
        </el-form-item>
        <el-form-item label="宽">
          <el-input v-model="model.width" placeholder="建议值：240、490、740、990"></el-input>
        </el-form-item>
        <el-form-item label="高">
          <el-input v-model="model.height" placeholder="建议值：480"></el-input>
        </el-form-item>
        <el-form-item label="左偏移">
          <el-input v-model="model.xoffset" placeholder="建议值：0、250、500..."></el-input>
        </el-form-item>
        <el-form-item label="顶偏移">
          <el-input v-model="model.yoffset" placeholder="建议值：10、510、1010..."></el-input>
        </el-form-item>
        <el-form-item label="边框色">
          <el-color-picker v-model="model.bordercolor" :predefine="predefineColors">
          </el-color-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="margin-top: -30px;">
        <el-button type="primary" @click="editCard">保存修改</el-button>
        <el-button type="primary" @click="addNewCard('x')">在此处横插入</el-button>
        <el-button type="primary" @click="addNewCard('y')">在此处纵插入</el-button>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="showSetting" width="330px" :show-close="false" top="1vh">
      <el-form label-width="100px">
        <el-form-item label="图表来源">
          <el-radio-group v-model="globalSetting.chartSource">
            <el-radio label="sina">新浪</el-radio>
            <el-radio label="eastmoney">东财</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="显示页面">
          <el-select v-model="displayPageId" placeholder="请选择1">
            <el-option v-for="page in pageList" :key="page.id" :label="page.name" :value="page.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="指数涨幅加粗">
          <el-input-number v-model="indexValueRank1" :precision="1" :step="0.1" :max="10"></el-input-number>
        </el-form-item>
        <el-form-item label="指数涨幅高亮">
          <el-input-number v-model="indexValueRank2" :precision="1" :step="0.1" :max="10"></el-input-number>
        </el-form-item>
        <el-form-item label="指数涨速加粗">
          <el-input-number v-model="indexSpeedRank1" :precision="1" :step="0.1" :max="10"></el-input-number>
        </el-form-item>
        <el-form-item label="指数涨速高亮">
          <el-input-number v-model="indexSpeedRank2" :precision="1" :step="0.1" :max="10"></el-input-number>
        </el-form-item>
        <el-form-item label="个股涨幅加粗">
          <el-input-number v-model="stockValueRank1" :step="1" :max="10"></el-input-number>
        </el-form-item>
        <el-form-item label="个股涨幅高亮">
          <el-input-number v-model="stockValueRank2" :step="1" :max="10"></el-input-number>
        </el-form-item>
        <el-form-item label="个股涨速加粗">
          <el-input-number v-model="stockSpeedRank1" :step="1" :max="10"></el-input-number>
        </el-form-item>
        <el-form-item label="个股涨速高亮">
          <el-input-number v-model="stockSpeedRank2" :step="1" :max="10"></el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="margin-top: -30px;">
        <el-button type="primary" @click="saveSetting">保存</el-button>
      </div>
    </el-dialog>

    <el-dialog title="添加/删除个股" width="400px" :visible.sync="showEditDialog">
      <el-form>
        <el-form-item label="" label-width="0px">
          <el-input v-model="editingDatalist" style="width:360px" @input="doCheckDataList"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="margin-top: -30px;">
        <el-button type="primary" @click="saveDatalist">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="资金情况" width="750px" top="1vh" :visible.sync="showMoneyChart">
      <div style="margin: -30px 10px -30px 90px;">
        <el-form>
          <el-form-item label="显示天数：" label-width="120px">
            <el-slider v-model="moneyChartDays" :step="1" show-stops show-input @change="doShowMoneyChart"
              style="width:400px;">
            </el-slider>
          </el-form-item>
        </el-form>
      </div>
      <div class="analysisTask">
        <ChartLine ref="chart_line_one" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ChartLine from '../components/ChartLine.vue'
export default {
  components: {
    ChartLine,
  },
  props: {
    codes: {}
  },
  data() {
    return {
      globalSetting: {
        chartSource: 'eastmoney'   // k线和分时图的源站，可选项：'sina', 'eastmoney'
      },
      apiUrl: {
        iwencai: 'https://www.iwencai.com/unifiedwap/result?w=',
        iwencaiApi: 'http://stock-dashboard.data-mc.cn/wencai/get_stock_info?query=',
        akStockHist: 'http://stock-dashboard.data-mc.cn/aktools/api/public/stock_zh_a_hist?symbol=',
      },
      baseSetting: {
        chartStyle: {
          sina: {
            chartK: 'width: 545px; height: 300px',
            chartMin: 'width: 545px; height: 300px'
          },
          eastmoney: {
            chartK: 'width: 520px; height: 365px',
            chartMin: 'width: 578px; height: 276px'
          },
        }
      },
      displayPageId: 1,
      traceDays: 30,
      cardSplitValueStr: '8,3',
      pageList: [],
      speedCategory: 'normal',
      indexValueRank1: 1.5,
      indexValueRank2: 2.5,
      indexSpeedRank1: 0.2,
      indexSpeedRank2: 0.5,
      stockValueRank1: 3,
      stockValueRank2: 8,
      stockSpeedRank1: 1,
      stockSpeedRank2: 3,
      predefineColors: [
        '#ff4500',
        '#ff8c00',
        '#ffd700',
        '#90ee90',
        '#00ced1',
        '#1e90ff',
        '#c71585',
        'rgba(255, 69, 0, 0.68)',
        'rgb(255, 120, 0)',
        'hsv(51, 100, 98)',
        'hsva(120, 40, 94, 0.5)',
        'hsl(181, 100%, 37%)',
        'hsla(209, 100%, 56%, 0.73)',
        '#c7158577'
      ],
      nameHistory: '历史资金流入情况',
      xDataHistory: ['2022-11-21', '2022-11-22', '2022-11-23', '2022-11-24'],
      yDataHistory: {
        price: [22.01, 21.56, 21.6, 21.7],
        netvalue: [60016233, -41375850, -88210086, -111944751],
        small: [-37446336, 45166498, 63529019, 95504633],
        middle: [-49566958, -7342028, -55474315, -114331345],
        big: [72171520, 52963097, 29266442, 1329324],
        super: [-12155287, -94338947, -117476528, -113274075]
      },
      nameRealtime: '实时资金流入情况',
      xDataRealtime: ['2022-11-21', '2022-11-22', '2022-11-23', '2022-11-24'],
      yDataRealtime: {
        price: [22.01, 21.56, 21.6, 21.7],
        netvalue: [60016233, -41375850, -88210086, -111944751],
        small: [-37446336, 45166498, 63529019, 95504633],
        middle: [-49566958, -7342028, -55474315, -114331345],
        big: [72171520, 52963097, 29266442, 1329324],
        super: [-12155287, -94338947, -117476528, -113274075]
      },
      showSetting: false,
      showMoneyChart: false,
      moneyChartDays: 100,
      editingDatalist: '',
      showEditDialog: false,
      targetEditCardIndex: -1,
      sortStatus: false,
      showChartDialog: false,
      selectedCode: '000001',
      showMoveDialog: false,
      targetMoveCardIndex: -1,
      cardLastValue: [],
      chartK: '',
      chartMin: '',
      F10ThsUrl: '',
      F10EmUrl: '',
      moneyNetValueEmUrl: '',
      cardList: [//默认div块的信息 为空的时候只能新增不能修改
        {
          width: "240px",
          xoffset: "0px",
          yoffset: "40px",
          title: '连续下跌',
          url: '/stock_rank_lxxd_ths',
          datalist_arr: [{ 'code': '002423', 'market': 'sz', '股票名称': '以岭药业', 'value': '9.8' }],
          fieldlist_arr: ['code', '股票名称']
        }
      ],
      plateList: [{
        core_avg_pcp: -0.012979527948,
        plate_id: 328,
        plate_name: "军工混改",
        reason: "中国兵器装备集团旗下，主营…"
      }]
    }
  },
  computed: {//处理data中的数据，返回处理后的结果
    // 格式与methods简写相似，但是不是方法，是属性，不能传参
    editedDatalist() {
      // 返回计算后的属性值
      return this.editingDatalist.replaceAll("，", ",").replaceAll(".", ",")
    },
    model() {
      const index = this.targetMoveCardIndex == -1 ? 0 : this.targetMoveCardIndex
      return this.cardList[index]
      // return JSON.parse(JSON.stringify(this.cardList[index]))
    }
  },
  methods: {
    // 把连板card的日期刷新为最近日期
    async setLianBanNewest() {
      // console.log(this.cardList)
      const url = this.baseAKToolsURL + '/tool_trade_date_hist_sina'
      const res = await this.$http.get(url);
      // 倒序遍历res.data，每个元素的trade_date值前10位转换为日期格式，如果小于今天，则加入数组中
      const today = new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate()
      const tradeDates = []
      for (let i = res.data.length - 1; i >= 0; i--) {
        const date = res.data[i].trade_date.substring(0, 10)
        if (new Date(date + ' 00:00:00').getTime() <= new Date(today + ' 00:00:00').getTime()) { // 日期必须加上时分秒，否则2024-12-05和2024-12-5的getTime值不一致，导致日期少一天
          // 2024-10-10格式转为20241010格式
          tradeDates.push(date.replace(/-/g, ''))
        }
        if (tradeDates.length == 20) {// 只要最近10个交易日，则停止
          break
        }
      }
      // 遍历cardList，找到title_text为'连板'的card，依次修改为最新交易日，并提交修改请求
      let flag = 0;
      this.cardList.forEach(async v => {
        if (v.title_text == '连板' && flag < tradeDates.length) {
          v.title = '连板' + tradeDates[flag].substr(4,4)
          v.url = '/continuous_limit_up?date=' + tradeDates[flag]
          console.log(flag, v.title + ',' + v.url)
          flag++

          // 提交修改请求
          const { id, type, page_id, title, url, datalist, fieldmap, fieldlist, iwencai, width, height, xoffset, yoffset, bordercolor } = v
          const newModel = { type, page_id, title, url, datalist, fieldmap, fieldlist, iwencai, width, height, xoffset, yoffset, bordercolor }
          const res = await this.$http.put(this.baseURL + '/rest/card/' + id, newModel)
          if (res.status == 200) {
            this.$message({
              message: '保存成功' + title,
              type: 'success'
            });
          } else {
            this.$message.error('保存出错');
          }

        }
      })
    },
    saveSetting() {
      this.showSetting = false
      if (this.cardList[0].page_id - this.displayPageId != 0) {//切换显示的页面
        this.fetch()
      }
    },
    lastOne() {
      // 上键，显示上一个股票的K线和分时
      let code
      if (this.cardList[this.targetEditCardIndex].type - 0 == 3 || this.cardList[this.targetEditCardIndex].type - 0 == 4) {
        const selectdCodeFlag = this.cardList[this.targetEditCardIndex].origin_datalist_arr.indexOf(this.selectedCode)
        const lastOneFlag = selectdCodeFlag - 1 >= 0 ? selectdCodeFlag - 1 : 0
        code = this.cardList[this.targetEditCardIndex].origin_datalist_arr[lastOneFlag]
      } else {
        let lastOneFlag
        this.cardList[this.targetEditCardIndex].datalist_arr.forEach((v, k) => {
          if (v.code == this.selectedCode) {
            lastOneFlag = k - 1 >= 0 ? k - 1 : 0
          }
        })
        code = this.cardList[this.targetEditCardIndex].datalist_arr[lastOneFlag].code
      }
      this.info(this.targetEditCardIndex, this.code2market(code), code)
    },
    nextOne() {
      // 下键，显示下一个股票的K线和分时
      let code
      if (this.cardList[this.targetEditCardIndex].type - 0 == 3 || this.cardList[this.targetEditCardIndex].type - 0 == 4) {
        const selectdCodeFlag = this.cardList[this.targetEditCardIndex].origin_datalist_arr.indexOf(this.selectedCode)
        const nextOneFlag = selectdCodeFlag + 1 >= this.cardList[this.targetEditCardIndex].origin_datalist_arr.length ? this.cardList[this.targetEditCardIndex].origin_datalist_arr.length : selectdCodeFlag + 1
        code = this.cardList[this.targetEditCardIndex].origin_datalist_arr[nextOneFlag]
      } else {
        let nextOneFlag
        this.cardList[this.targetEditCardIndex].datalist_arr.forEach((v, k) => {
          if (v.code == this.selectedCode) {
            nextOneFlag = k + 1 >= this.cardList[this.targetEditCardIndex].datalist_arr.length ? this.cardList[this.targetEditCardIndex].datalist_arr.length : k + 1
          }
        })
        code = this.cardList[this.targetEditCardIndex].datalist_arr[nextOneFlag].code
      }

      this.info(this.targetEditCardIndex, this.code2market(code), code)
    },
    // 复制股票代码
    copyCode() {
      let textToCopy = this.selectedCode
        // navigator clipboard 需要https等安全上下文
        if (navigator.clipboard && window.isSecureContext) {
          // navigator clipboard 向剪贴板写文本
          navigator.clipboard.writeText(textToCopy)
            .then(() => {
                console.log('文件名已复制到剪贴板-clipboard');
                return true;
            })
            .catch(err => {
                console.error('无法复制到剪贴板-clipboard：', err);
                return false;
            });
      } else {
            // document.execCommand('copy') 向剪贴板写文本
          let input = document.createElement('input')
          input.style.position = 'fixed'
          input.style.top = '-10000px'
          input.style.zIndex = '-999'
          document.body.appendChild(input)
          input.value = textToCopy
          input.focus()
          input.select()
          try {
            let result = document.execCommand('copy')
            document.body.removeChild(input)
            if (!result || result === 'unsuccessful') {
              console.log('文件名复制失败-copy')
            } else {
              console.log('文件名已复制到剪贴板-copy')
            }
          } catch (e) {
            document.body.removeChild(input)
            alert('当前浏览器不支持复制功能，请检查更新或更换其他浏览器操作')
          }
      }
    },
    async editCard() {
      const { id, type, page_id, title, url, datalist, fieldmap, fieldlist, iwencai, width, height, xoffset, yoffset, bordercolor } = this.model
      const newModel = { type, page_id, title, url, datalist, fieldmap, fieldlist, iwencai, width, height, xoffset, yoffset, bordercolor }
      const res = await this.$http.put(this.baseURL + '/rest/card/' + id, newModel)
      this.showMoveDialog = false
      if (res.status == 200) {
        this.$message({
          message: '保存成功',
          type: 'success'
        });
        if ((type == 3 || type == 4 || type == 5) && this.cardList[this.targetMoveCardIndex].datalist.length > 0) {
          this.cardList[this.targetMoveCardIndex].origin_datalist_arr = this.cardList[this.targetMoveCardIndex].datalist.split(',')
          this.cardList[this.targetMoveCardIndex].datalist_arr = this.cardList[this.targetMoveCardIndex].origin_datalist_arr
        }
      } else {
        this.$message.error('保存出错');
      }
    },
    async addNewCard(direct = 'x') {
      //插入新card
      const { type, title, page_id, url, datalist, fieldmap, fieldlist, iwencai, width, height, xoffset, yoffset, bordercolor } = this.model
      const newModel = { type, title, page_id, url, datalist, fieldmap, fieldlist, iwencai, width, height, xoffset, yoffset, bordercolor }
      const res = await this.$http.post(this.baseURL + '/rest/card', newModel)
      if (res.status == 200) {
        this.$message({
          message: '插入成功',
          type: 'success'
        });
      } else {
        this.$message.error('插入出错');
      }

      //给新card腾空间
      const that = this
      this.cardList.forEach((item, index) => {
        if(direct == 'x'){
          if (item.yoffset == yoffset && item.xoffset >= xoffset) {//给新card腾空间：在同一行且靠右的card 统一向右移一个card的宽度
            that.targetMoveCardIndex = index
            that.move('xoffset', 250)
          }
        }else if(direct == 'y'){
          if (item.xoffset == xoffset && item.yoffset >= yoffset) {//给新card腾空间：在同一列且靠下的card 统一向下移一个card的高度
            that.targetMoveCardIndex = index
            that.move('yoffset', 500)
          }
        }else{
          console.log('error')
        }
      })

      this.fetch()
      this.showMoveDialog = false
    },
    doCheckDataList(){
      // 获取数据列表，删除空格
      this.editingDatalist = this.editingDatalist.replaceAll("，", ",").replaceAll(".", ",").replaceAll(" ", "")
      // 检查this.editingDatalist，其格式必须是每6位字符就有一个英文逗号，也就是说7n必是英文逗号，如果不符合，则自动添加
      for (let i = 0; i < this.editingDatalist.length; i++) {
        if ((i + 1) % 7 == 0 && this.editingDatalist[i] != ',') {
          this.editingDatalist = this.editingDatalist.slice(0, i).concat(',').concat(this.editingDatalist.slice(i))
        }
      }


    },
    async doShowMoneyChart() {
      this.showMoneyChart = true
      this.xDataHistory = []
      this.yDataHistory.price = []
      this.yDataHistory.netvalue = []
      this.yDataHistory.small = []
      this.yDataHistory.middle = []
      this.yDataHistory.big = []
      this.yDataHistory.super = []
      this.xDataRealtime = []
      this.yDataRealtime.price = []
      this.yDataRealtime.netvalue = []
      this.yDataRealtime.small = []
      this.yDataRealtime.middle = []
      this.yDataRealtime.big = []
      this.yDataRealtime.super = []
      const resHistory = await this.$http.get(this.baseURL + '/money_net_value/history/' + this.selectedCode)
      const resRealtime = await this.$http.get(this.baseURL + '/money_net_value/realtime/' + this.selectedCode)
      const resFenshi = await this.$http.get(this.baseURL + '/fenshi_data/' + this.selectedCode)
      const that = this
      const startFlag = resHistory.data.length - this.moneyChartDays > 0 ? resHistory.data.length - this.moneyChartDays : 0
      resHistory.data.forEach((item, key) => {
        const tmpArr = item.split(',')
        if (key - startFlag == 0) {
          that.xDataHistory.push(tmpArr[0])
          that.yDataHistory.price.push(tmpArr[11])
          that.yDataHistory.netvalue.push(tmpArr[1] - 0)
          that.yDataHistory.small.push(tmpArr[2] - 0)
          that.yDataHistory.middle.push(tmpArr[3] - 0)
          that.yDataHistory.big.push(tmpArr[4] - 0)
          that.yDataHistory.super.push(tmpArr[5] - 0)
        } else if (key - startFlag > 0) {
          that.xDataHistory.push(tmpArr[0])
          that.yDataHistory.price.push(tmpArr[11])
          that.yDataHistory.netvalue.push(that.yDataHistory.netvalue.at(-1) + (tmpArr[1] - 0))
          that.yDataHistory.small.push(that.yDataHistory.small.at(-1) + (tmpArr[2] - 0))
          that.yDataHistory.middle.push(that.yDataHistory.middle.at(-1) + (tmpArr[3] - 0))
          that.yDataHistory.big.push(that.yDataHistory.big.at(-1) + (tmpArr[4] - 0))
          that.yDataHistory.super.push(that.yDataHistory.super.at(-1) + (tmpArr[5] - 0))
        }
      })
      resRealtime.data.forEach(item => {
        const tmpArr = item.split(',')
        that.xDataRealtime.push(tmpArr[0])
        that.yDataRealtime.netvalue.push(tmpArr[1] - 0)
        that.yDataRealtime.small.push(tmpArr[2] - 0)
        that.yDataRealtime.middle.push(tmpArr[3] - 0)
        that.yDataRealtime.big.push(tmpArr[4] - 0)
        that.yDataRealtime.super.push(tmpArr[5] - 0)
      })
      resFenshi.data.forEach(item => {
        const tmpArr = item.split(',')
        that.yDataRealtime.price.push(tmpArr[1])
      })

      const { nameHistory, xDataHistory, yDataHistory, nameRealtime, xDataRealtime, yDataRealtime } = this
      console.log(this.$refs)
      this.$refs.chart_line_one.initChart(nameHistory, xDataHistory, yDataHistory, nameRealtime, xDataRealtime, yDataRealtime)
    },
    isUndefined(data) {
      if (Object.prototype.toString.call(data) === '[object Undefined]') {
        return true
      } else {
        return false
      }
    },
    isNull(data) {
      if (Object.prototype.toString.call(data) === '[object Null]') {
        return true
      } else {
        return false
      }
    },
    // 是否指数，目前仅标记BK开头的东财指数、5开头的沪基、15开头的深基
    codeIsIndex(code) {
      const indexArr = ['000001', '000688', '000300', '000016']  //沪市指数但开头不是6的code，要特殊处理
      if (indexArr.indexOf(code) >= 0)
        return true //沪市指数但开头不是6
      else if (code.substr(0, 2) == 'BK')
        return true //BK开头的东财指数
      else if (code.substr(0, 1) == '5')
        return true //51、56是沪基，其它5开头也都按沪市处理
      else if (code.substr(0, 2) == '15')
        return true //深基
      else
        return false //其它按深市处理
    },
    // 6位股票代码加sh/sz前缀，兼容指数
    code2market(code) {
      const indexArr = ['000001', '000688', '000300', '000016']  //沪市指数但开头不是6的code，要特殊处理
      if (indexArr.indexOf(code) >= 0)
        return 'sh' //沪市指数但开头不是6
      else if (code.substr(0, 1) == '8')
        return 'bj' //北交所
      else if (code.substr(0, 1) == '6')
        return 'sh' //沪市
      else if (code.substr(0, 1) == '5')
        return 'sh' //51、56是沪基，其它5开头也都按沪市处理
      else if (code.substr(0, 2) == '11')
        return 'sh' //沪可转债
      else if (code.substr(0, 1) == '0')
        return 'sz' //深市
      else if (code.substr(0, 1) == '3')
        return 'sz' //创业板
      else if (code.substr(0, 2) == '15')
        return 'sz' //深基
      else if (code.substr(0, 2) == '12')
        return 'sz' //深可转债
      else
        return 'sz' //其它按深市处理
    },
    // 6位股票代码加1./0.前缀，兼容指数，兼容东财接口
    code2EastMoneyMarket(code) {
      const indexArr = ['000001', '000688', '000300', '000016']  //沪市指数但开头不是6的code，要特殊处理
      if (indexArr.indexOf(code) >= 0)
        return '1.' //沪市指数但开头不是6
      else if (code.substr(0, 2) == 'BK')
        return '90.' //东财的指数
      else if (code.substr(0, 1) == '8')
        return '0.' //北交所
      else if (code.substr(0, 1) == '6')
        return '1.' //沪市
      else if (code.substr(0, 1) == '5')
        return '1.' //51、56是沪基，其它5开头也都按沪市处理
      else if (code.substr(0, 2) == '11')
        return '1.' //沪可转债
      else if (code.substr(0, 1) == '0')
        return '0.' //深市
      else if (code.substr(0, 1) == '3')
        return '0.' //创业板
      else if (code.substr(0, 2) == '15')
        return '0.' //深基
      else if (code.substr(0, 2) == '12')
        return '0.' //深可转债
      else
        return '0.' //其它按深市处理
    },
    getChartKUrl(code) {
      let url
      if(this.globalSetting.chartSource == 'sina'){
        url = 'https://image.sinajs.cn/newchart/daily/n/' + this.code2market(code) + code + '.gif'
      }else if(this.globalSetting.chartSource == 'eastmoney'){
        url = 'https://webquoteklinepic.eastmoney.com/GetPic.aspx?nid=' + this.code2EastMoneyMarket(code) + code + '&type=&unitWidth=-6&ef=&formula=MACD&imageType=KXL'
      }else{
        url = 'https://image.sinajs.cn/newchart/daily/n/' + this.code2market(code) + code + '.gif'
      }
      return url
    },
    getChartMinUrl(code) {
      let url
      if(this.globalSetting.chartSource == 'sina'){
        url = 'https://image.sinajs.cn/newchart/min/n/' + this.code2market(code) + code + '.gif'
      }else if(this.globalSetting.chartSource == 'eastmoney'){
        url = 'https://webquotepic.eastmoney.com/GetPic.aspx?imageType=rp&nid=' + this.code2EastMoneyMarket(code) + code + ''
      }else{
        url = 'https://image.sinajs.cn/newchart/min/n/' + this.code2market(code) + code + '.gif'
      }
      return url
    },
    // 弹窗显示k线、分时、所属板块及F10按钮
    info(index, market, code) {
      this.targetEditCardIndex = index
      this.showChartDialog = true
      this.selectedCode = code
      this.moneyChartDays = 100
      this.chartK = this.getChartKUrl(code)
      this.chartMin = this.getChartMinUrl(code)
      this.F10ThsUrl = 'http://basic.10jqka.com.cn/' + code
      this.F10EmUrl = 'https://data.eastmoney.com/stockdata/' + code + '.html'
      this.moneyNetValueEmUrl = 'https://data.eastmoney.com/zjlx/' + code + '.html'
      this.getPlates(code)
    },
    // 从选股宝获取所属板块及板块涨幅
    async getPlates(code) {
      const market = code.substr(0, 1) == '6' ? 'SS' : 'SZ'
      const url = this.platesByAnyStock.replace('600001', code).replace('SS', market)
      const res = await this.$http.get(url);
      const plates = Object.values(res.data.data)
      plates.sort((a, b) => { return b.core_avg_pcp - a.core_avg_pcp })
      this.plateList = plates
    },
    // 获取所有卡片数据
    async fetch() {
      const resPage = await this.$http.get(`${this.baseURL}/rest/page`)
      this.pageList = resPage.data
      document.title = this.pageList.filter(e => { return e.id == this.displayPageId })[0].name
      const rank_str = this.displayPageId == 1 ? '/xoffset+yoffset/asc+asc' : '/yoffset+xoffset/asc+asc' //默认看板优先纵向取100个card，其它看板优先横向取100个card
      const count = this.displayPageId == 1 ? 100 : 60 //默认看板优先取100个card，其它看板优先取60个card
      const res = await this.$http.get(`${this.baseURL}/rest/card/filter/status+page_id/1+${this.displayPageId}/rank${rank_str}/page/${count}/1`)
      res.data.forEach(item => {  //把映射表、显示字段处理成数组
        item.datalist_arr = this.isNull(item.datalist) ? [] : item.datalist.split(',')
        item.origin_datalist_arr = item.datalist_arr
        item.fieldlist_arr = this.isNull(item.fieldlist) ? [] : item.fieldlist.split(',')
        item.fieldmap_arr = this.isNull(item.fieldmap) ? [] : item.fieldmap.split(',')
        item.title_text = item.title.substr(0,2)
      })
      this.cardList = res.data
      this.refreshCard(0)
    },
    // 检查对象数组中，是否有涨幅/名称，没有则获取，使用腾讯股票api（无涨速数据）
    async checkValueTencent(datalist_arr) {
      // console.log(datalist_arr)
      const codeArr = []
      datalist_arr.forEach(element => {
        if (this.isUndefined(element.value) || this.isNull(element.value)) {
          codeArr.push(element.market + element.code)
        }
      });

      if (codeArr.length == datalist_arr.length) { //为了兼容个别停牌的情况：只有全部没有涨幅数据时，再获取
        const price_api = 'https://qt.gtimg.cn/q=' + codeArr.join(',')
        const resData = await this.$http.get(price_api);
        const tmpResArr = resData.data.split(';\n') //分割成每个stock数据
        const resDataObj = {}
        tmpResArr.forEach(element => {
          if (element.length > 0) {
            const tmp = element.split('=') //分割出代码和数据
            resDataObj[tmp[0]] = tmp[1] //存入对象
          }
        })

        datalist_arr.forEach(item => {
          const stock = item.market + item.code
          const stockData = resDataObj['v_' + stock].split('~')
          item.name = stockData[1]
          item.price = stockData[4]
          item.value = stockData[32]
        });
      }
      return datalist_arr
    },
    // 检查对象数组中，是否有涨幅/名称，没有则获取，使用东财股票api（有涨速数据）
    async checkValueEastmoney(datalist_arr) {
      const codeArr = []
      datalist_arr.forEach(element => {
        codeArr.push(this.code2EastMoneyMarket(element.code) + element.code)
      });

      if (codeArr.length == datalist_arr.length) { //为了兼容个别停牌的情况：只有全部没有涨幅数据时，再获取
        const price_api = 'http://push2.eastmoney.com/api/qt/ulist.np/get?fltt=2&fields=f12,f14,f3,f22&secids=' + codeArr.join(',')
        const resData = await this.$http.get(price_api);
        const tmpResArr = resData.data.data.diff

        datalist_arr.forEach(item => {
          const tmp = tmpResArr.filter(a => { return a.f12 == item.code })[0]
          item.name = tmp.f14
          item.price = tmp.f2
          item.value = tmp.f3.toFixed(2)
          if (this.speedCategory == 'normal') {
            item.speed = tmp.f22.toFixed(2)
          } else {
            const lastItem = this.cardLastValue.filter(a => { return a.code == item.code })[0]
            item.speed = lastItem ? (item.value - lastItem.value).toFixed(2) : item.value
          }
          item.isIndex = this.codeIsIndex(item.code) //判断是否指数，显示时涨幅、涨速加粗阈值不同
        });
      }
      return datalist_arr
    },
    // 计算涨幅平均值
    calcAverage(datalist_arr) {
      let sum = 0
      datalist_arr.forEach(item => {
        sum += !isNaN(Number(item.value)) ? item.value - 0 : 0  //停牌等原因会出现NaN
      })
      return Math.round(sum / datalist_arr.length * 100) / 100
    },
    // 刷新所有卡片
    async refreshAll(index) {
      let count = 0
      const yoffset = this.cardList[index].yoffset
      const xoffset = this.cardList[index].xoffset
      for (let x = 0; x < this.cardList.length; x++) {
        if (count <= 10 && this.cardList[x].yoffset == yoffset && this.cardList[x].xoffset >= xoffset && (this.cardList[x].type == 2 || this.cardList[x].type == 3 || this.cardList[x].type == 4 || this.cardList[x].type == 5)) {
          this.refreshCard(x)
          count++
        }
      }
    },
    // 本行所有卡片，从问财api更新股票代码列表
    async getStockListFromIwencaiAll(index) {
      let count = 0
      const yoffset = this.cardList[index].yoffset
      const xoffset = this.cardList[index].xoffset - 500 // 因为触发按钮加在了第3个card上，所以xoffset要减500
      for (let x = 0; x < this.cardList.length; x++) {
        if (count <= 10 && this.cardList[x].yoffset == yoffset && this.cardList[x].xoffset >= xoffset && this.cardList[x].type == 5) {
          this.getStockListFromIwencai(x)
          count++
        }
      }
    },
    // 刷新某卡片数据
    async refreshCard(index, speedCategory = 'normal') {//添加speedCategory参数，默认为normal表示显示常规涨速，如果参数值为change表示显示“本地涨速”
      this.speedCategory = speedCategory
      this.cardLastValue = this.cardList[index].datalist_arr //把当前涨幅存一下，将来计算“本地涨速”使用

      let tmpDatalistArr = []
      if (this.cardList[index].type - 0 == 3 || this.cardList[index].type - 0 == 4 || this.cardList[index].type - 0 == 5) {
        this.cardList[index].origin_datalist_arr.forEach(item => {
          const market = this.code2market(item)  //增加market列，方便请求第三方数据
          tmpDatalistArr.push({ code: item, market: market })
        })

        if (this.cardList[index].type == 4 || this.cardList[index].type == 5) {
          let rightCard
          if (this.cardList[index].type == 4) {
            rightCard = this.cardList.filter(a => { return a.type == 4 && a.yoffset == this.cardList[index].yoffset && a.xoffset - this.cardList[index].xoffset == 250 })[0]
          }
          if (this.cardList[index].type == 5) {
            rightCard = this.cardList.filter(a => { return a.type == 5 && a.xoffset == this.cardList[index].xoffset && a.yoffset - this.cardList[index].yoffset == 500 })[0]
          }
          tmpDatalistArr.forEach((v, k) => {
            const rightCardCodeArr = rightCard ? rightCard.origin_datalist_arr : []
            const lastDayRank = rightCardCodeArr.indexOf(v.code) + 1
            const changeRank = lastDayRank - (k + 1)
            if (lastDayRank == 0) {
              v.changeRankValue = '0'
              v.changeRank = '+'
            } else if (changeRank < 0) {
              v.changeRankValue = changeRank
              v.changeRank = '↓' + changeRank
            } else if (changeRank > 0) {
              v.changeRankValue = '+' + changeRank
              v.changeRank = '↑' + changeRank
            } else {
              v.changeRankValue = ''
              v.changeRank = ''
            }
          });
        }

      } else {
        const url = this.cardList[index].type - 0 == 1 ? this.baseAKToolsURL + this.cardList[index].url : this.baseURL + this.cardList[index].url
        const res = await this.$http.get(url);
        res.data.forEach(element => {
          this.cardList[index].fieldmap_arr.forEach(item => { //按映射表对字段进行重命名，方便统一展示
            const tmpMap = item.split('%%')                //数据库的映射表分隔符
            element[tmpMap[1]] = element[tmpMap[0]]
          })

          if (!this.isUndefined(element.code)) {          //如果有code列，才处理
            if (element.code.length > 6) {                  //将非规范code处理为6位数字
              const regexPreCode = /^[shzSHZ]{2}\d{6}$/
              if (regexPreCode.test(element.code)) {
                element.code = element.code.substr(2, 6)
              } else {
                element.code = element.code.substr(0, 6)
              }
            }
            element.market = this.code2market(element.code) //增加market列，方便请求第三方数据
          }

          if (this.isUndefined(element.value) || this.isNull(element.value)) {
            // codeArr.push(element.market + element.code)
          } else {
            if (String(element.value).slice(-1) == '%') { //涨幅如果有%，则去掉
              element.value = element.value.substr(0, element.value.length - 1)
            }
          }
        });
        tmpDatalistArr = res.data
      }
      if (Object.keys(tmpDatalistArr[0]).indexOf('code') >= 0) {
        const okDatalistArr = await this.checkValueEastmoney(tmpDatalistArr)
        const average = this.calcAverage(okDatalistArr)
        this.cardList[index].datalist_arr = okDatalistArr
        this.cardList[index].average = isNaN(average) ? 0 : average
      } else {
        this.cardList[index].datalist_arr = tmpDatalistArr
      }
    },
    jumpChart(index) {
      console.log(this.cardList[index])
      const codeArr = []
      this.cardList[index].datalist_arr.forEach(element => {
        codeArr.push(element.code)
      })
      const routeData = this.$router.resolve('/chart/' + codeArr.join(','))
      window.open(routeData.href, '_blank');
    },
    sortValue(index) {
      this.sortStatus = !this.sortStatus
      if (this.sortStatus) {
        this.cardList[index].datalist_arr.sort((a, b) => { return b.value - a.value })
      } else {
        this.cardList[index].datalist_arr.sort((a, b) => { return a.value - b.value })
      }
    },
    // 从问财获取新股票代码列表
    async getStockListFromIwencai(index) {
      const card = this.cardList[index]
      if (card.type == 5) {
        const url = this.apiUrl.iwencaiApi + card.iwencai
        try{
          const res = await this.$http.get(url);

          const arr = []
          res.data.forEach(item => { 
            arr.push(item.code)
          })

          this.targetEditCardIndex = index
          this.editingDatalist = arr.join(',')
          this.saveDatalist()
        }catch (error) {
          console.log(error)
          this.$message({
            message: error.response.data,
            type: 'error'
          })
        }
      }
    },
    addStock(index) {
      const card = this.cardList[index]
      if (card.type == 3 || card.type == 4) {
        this.targetEditCardIndex = index
        this.editingDatalist = this.cardList[index].origin_datalist_arr.length == 0 ? this.selectedCode : this.selectedCode + ',' + this.cardList[index].origin_datalist_arr.join(',')
        this.editingDatalist = [...new Set(this.editingDatalist.split(','))].join(',') //去重
        this.saveDatalist()
      }
    },
    moveStock(offset) {
      const index = this.targetEditCardIndex
      const flag = this.cardList[index].origin_datalist_arr.indexOf(this.selectedCode)
      this.cardList[index].origin_datalist_arr.splice(flag, 1)
      let newFlag = flag + offset
      if (newFlag < 0) newFlag = 0
      if (newFlag > this.cardList[index].origin_datalist_arr.length) newFlag = this.cardList[index].origin_datalist_arr.length
      this.cardList[index].origin_datalist_arr.splice(newFlag, 0, this.selectedCode)
      this.editingDatalist = this.cardList[index].origin_datalist_arr.join(',')
      this.saveDatalist()
    },
    delStock() {
      const index = this.targetEditCardIndex
      const flag = this.cardList[index].origin_datalist_arr.indexOf(this.selectedCode)
      this.cardList[index].origin_datalist_arr.splice(flag, 1)
      this.editingDatalist = this.cardList[index].origin_datalist_arr.join(',')
      this.saveDatalist()
    },
    showMove(index) {
      if (this.targetMoveCardIndex == index) {
        this.showMoveDialog = true
      }
      this.targetMoveCardIndex = index
    },
    async move(arrow, value) {
      this.showMoveDialog = false
      this.cardList[this.targetMoveCardIndex][arrow] = this.cardList[this.targetMoveCardIndex][arrow] + value < 0 ? this.cardList[this.targetMoveCardIndex][arrow] : this.cardList[this.targetMoveCardIndex][arrow] + value //防止小于0
      const newForm = arrow == 'xoffset' ? { xoffset: this.cardList[this.targetMoveCardIndex][arrow] } : { yoffset: this.cardList[this.targetMoveCardIndex][arrow] }
      const id = this.cardList[this.targetMoveCardIndex].id
      await this.$http.put(this.baseURL + `/rest/card/${id}`, newForm)
    },
    editDatalist(index) {
      // console.log(index)
      // this.targetEditCardIndex = this.cardList[index].id
      this.targetEditCardIndex = index
      this.editingDatalist = this.cardList[index].origin_datalist_arr.join(',')
      this.showEditDialog = true
    },
    async saveDatalist() {
      this.showEditDialog = false
      const newForm = { datalist: this.editedDatalist }
      const res = await this.$http.put(this.baseURL + `/rest/card/${this.cardList[this.targetEditCardIndex].id}`, newForm)
      // const res = await this.$http.put(this.baseURL + `/rest/card/${this.targetEditCardIndex}`, newForm)
      if (res.status == 200) {
        this.cardList[this.targetEditCardIndex].origin_datalist_arr = this.editedDatalist.length > 0 ? this.editedDatalist.split(',') : []
        this.cardList[this.targetEditCardIndex].datalist_arr = this.cardList[this.targetEditCardIndex].origin_datalist_arr
        // const that = this
        // this.cardList.forEach(item => {
        //   if (item.id == that.targetEditCardIndex) {
        //     item.origin_datalist_arr = that.editedDatalist.length > 0 ? that.editedDatalist.split(',') : []
        //     item.datalist_arr = item.origin_datalist_arr
        //   }
        // })
        this.refreshCard(this.targetEditCardIndex)
      }
    },
    async getDateArr(days) {
      // console.log(this.cardList)
      const url = this.baseAKToolsURL + '/tool_trade_date_hist_sina'
      const res = await this.$http.get(url);
      // 倒序遍历res.data，每个元素的trade_date值前10位转换为日期格式，如果小于今天，则加入数组中
      const today = new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate()
      const tradeDates = []
      for (let i = res.data.length - 1; i >= 0; i--) {
        const date = res.data[i].trade_date.substring(0, 10)
        if (new Date(date + ' 00:00:00').getTime() <= new Date(today + ' 00:00:00').getTime()) { // 日期必须加上时分秒，否则2024-12-05和2024-12-5的getTime值不一致，导致日期少一天
          // 2024-10-10格式转为20241010格式
          tradeDates.push(date.replace(/-/g, ''))
        }
        if (tradeDates.length == days) {// 只要最近x个交易日，则停止
          break
        }
      }
      return tradeDates
    },
    // 获取近x天涨停过的股票，并根据每天的涨幅生成cardlist
    async fetchLimitUpCardList() {
      const days = this.$route.query.days || 30  // 不传参的话，默认30天
      
      // 获取traceDays天之前的日期
      const traceDaysArr = await this.getDateArr(days)
      const startDate = traceDaysArr[traceDaysArr.length - 1]

      // 从问财获取days天以内的涨停股票，得到code数组
      const wencaiStr = startDate + '至今涨停次数大于等于2的股票，剔除st北交所'
      const url = this.apiUrl.iwencaiApi + wencaiStr
      const codeArr = []
      try{
        const res = await this.$http.get(url);

        res.data.forEach(item => { 
          codeArr.push(item.code)
        })
      }catch (error) {
        console.log(error)
        this.$message({
          message: error.response.data,
          type: 'error'
        })
      }

      // toast提示
      this.$message({
        message: '共' + codeArr.length + '支股票，即将依次请求' + days + '天内的历史数据，预计1分钟/500支，请耐心等待...',
        type: 'success'
      })

      // 根据code数组获取股票名称等信息
      const codeTmpArr = []
      codeArr.forEach(element => {
        codeTmpArr.push(this.code2EastMoneyMarket(element) + element)
      });

      let stockInfoList
      if (codeTmpArr.length == codeArr.length) { //为了兼容个别停牌的情况：只有全部没有涨幅数据时，再获取
        const price_api = 'http://push2.eastmoney.com/api/qt/ulist.np/get?fltt=2&fields=f12,f14,f3,f22&secids=' + codeTmpArr.join(',')
        const resData = await this.$http.get(price_api);
        stockInfoList = resData.data.data.diff
      }

      // 遍历codeArr，获取历史涨幅数据
      const stockDataList = []
      for (let i = 0; i < codeArr.length; i++) {
        const code = codeArr[i]
        const url = this.apiUrl.akStockHist + code + '&start_date=' + startDate
        const res = await this.$http.get(url)
        const tmpArr = []
        res.data.forEach(item => {
          tmpArr.push(item['涨跌幅'])
        })

        const stockName = stockInfoList.find(item => item.f12 == code).f14
        const tmpObj = {
          code: code,
          name: stockName,
          markey: this.code2market(code),
          data: tmpArr
        }
        stockDataList.push(tmpObj)
      }

      // 遍历traceDaysArr，生成cardlist
      const cardList = []
      for (let i = 0; i < traceDaysArr.length; i++) {
        const date = traceDaysArr[i]
        
        const card0 = {
          width: 240,
          height: 480,
          xoffset: 0,
          yoffset: 500*i + 10,
          title: date + '-9',
          url: '/stock_rank_lxxd_ths',
          datalist_arr: [{ 'code': '300033', 'market': 'sz', '股票名称': '以岭药业', 'value': '9.8' }],
          fieldlist_arr: ['code', '股票名称']
        }
        const card1 = {
          width: 240,
          height: 480,
          xoffset: 250,
          yoffset: 500*i + 10,
          title: date + '-5',
          url: '/stock_rank_lxxd_ths',
          datalist_arr: [{ 'code': '300033', 'market': 'sz', '股票名称': '以岭药业', 'value': '9.8' }],
          fieldlist_arr: ['code', '股票名称']
        }
        const card2 = {
          width: 240,
          height: 480,
          xoffset: 500,
          yoffset: 500*i + 10,
          title: date + '+5',
          url: '/stock_rank_lxxd_ths',
          datalist_arr: [{ 'code': '300033', 'market': 'sz', '股票名称': '以岭药业', 'value': '9.8' }],
          fieldlist_arr: ['code', '股票名称']
        }
        const card3 = {
          width: 240,
          height: 480,
          xoffset: 750,
          yoffset: 500*i + 10,
          title: date + '+9',
          url: '/stock_rank_lxxd_ths',
          datalist_arr: [{ 'code': '300033', 'market': 'sz', '股票名称': '以岭药业', 'value': '9.8' }],
          fieldlist_arr: ['code', '股票名称']
        }
        const card4 = {
          width: 240,
          height: 480,
          xoffset: 1000,
          yoffset: 500*i + 10,
          title: date + '-1板',
          url: '/stock_rank_lxxd_ths',
          datalist_arr: [{ 'code': '300033', 'market': 'sz', '股票名称': '以岭药业', 'value': '9.8' }],
          fieldlist_arr: ['code', '股票名称']
        }
        const card5 = {
          width: 240,
          height: 480,
          xoffset: 1250,
          yoffset: 500*i + 10,
          title: date + '-2板',
          url: '/stock_rank_lxxd_ths',
          datalist_arr: [{ 'code': '300033', 'market': 'sz', '股票名称': '以岭药业', 'value': '9.8' }],
          fieldlist_arr: ['code', '股票名称']
        }
        const card6 = {
          width: 240,
          height: 480,
          xoffset: 1500,
          yoffset: 500*i + 10,
          title: date + '-3板',
          url: '/stock_rank_lxxd_ths',
          datalist_arr: [{ 'code': '300033', 'market': 'sz', '股票名称': '以岭药业', 'value': '9.8' }],
          fieldlist_arr: ['code', '股票名称']
        }
        const card7 = {
          width: 240,
          height: 480,
          xoffset: 1750,
          yoffset: 500*i + 10,
          title: date + '-4板',
          url: '/stock_rank_lxxd_ths',
          datalist_arr: [{ 'code': '300033', 'market': 'sz', '股票名称': '以岭药业', 'value': '9.8' }],
          fieldlist_arr: ['code', '股票名称']
        }
        const card8 = {
          width: 240,
          height: 480,
          xoffset: 2000,
          yoffset: 500*i + 10,
          title: date + '-5板',
          url: '/stock_rank_lxxd_ths',
          datalist_arr: [{ 'code': '300033', 'market': 'sz', '股票名称': '以岭药业', 'value': '9.8' }],
          fieldlist_arr: ['code', '股票名称']
        }
        const card9 = {
          width: 240,
          height: 480,
          xoffset: 2250,
          yoffset: 500*i + 10,
          title: date + '-5+板',
          url: '/stock_rank_lxxd_ths',
          datalist_arr: [{ 'code': '300033', 'market': 'sz', '股票名称': '以岭药业', 'value': '9.8' }],
          fieldlist_arr: ['code', '股票名称']
        }

        // 遍历stockDataList，根据当天涨幅，分到不同card中
        const tmpArr = [[], [], [], [], [], [], [], [], [], []]
        stockDataList.forEach(item => {
          const code = item.code
          const data = item.data
          const value = data[traceDaysArr.length - i - 1]
          
          if (value < -9.5) {
            tmpArr[0].push({ 'code': code, 'market': item.market, '股票名称': item.name, 'value': value })
          }else if (value < -5) {
            tmpArr[1].push({ 'code': code, 'market': item.market, '股票名称': item.name, 'value': value })
          }else if (value < 5) {
            tmpArr[2].push({ 'code': code, 'market': item.market, '股票名称': item.name, 'value': value })
          }else if (value < 9.5) {
            tmpArr[3].push({ 'code': code, 'market': item.market, '股票名称': item.name, 'value': value })
          }else {
            if (data[traceDaysArr.length - i - 2] < 9.5) { // 如果1天前没涨停，就算首板
              tmpArr[4].push({ 'code': code, 'market': item.market, '股票名称': item.name, 'value': value })
            }else if (data[traceDaysArr.length - i - 3] < 9.5){ // 如果2天前没涨停，就算2板
              tmpArr[5].push({ 'code': code, 'market': item.market, '股票名称': item.name, 'value': value })
            }else if (data[traceDaysArr.length - i - 4] < 9.5){ // 如果3天前没涨停，就算3板
              tmpArr[6].push({ 'code': code, 'market': item.market, '股票名称': item.name, 'value': value })
            }else if (data[traceDaysArr.length - i - 5] < 9.5){ // 如果4天前没涨停，就算4板
              tmpArr[7].push({ 'code': code, 'market': item.market, '股票名称': item.name, 'value': value })
            }else if (data[traceDaysArr.length - i - 6] < 9.5){ // 如果5天前没涨停，就算5板
              tmpArr[8].push({ 'code': code, 'market': item.market, '股票名称': item.name, 'value': value })
            }else{ // 6板及以上
              tmpArr[9].push({ 'code': code, 'market': item.market, '股票名称': item.name, 'value': value })
            }
          }
        })

        card0.datalist_arr = tmpArr[0]
        card1.datalist_arr = tmpArr[1]
        card2.datalist_arr = tmpArr[2]
        card3.datalist_arr = tmpArr[3]
        card4.datalist_arr = tmpArr[4]
        card5.datalist_arr = tmpArr[5]
        card6.datalist_arr = tmpArr[6]
        card7.datalist_arr = tmpArr[7]
        card8.datalist_arr = tmpArr[8]
        card9.datalist_arr = tmpArr[9]
        
        cardList.push(card0)
        cardList.push(card1)
        cardList.push(card2)
        cardList.push(card3)
        cardList.push(card4)
        cardList.push(card5)
        cardList.push(card6)
        cardList.push(card7)
        cardList.push(card8)
        cardList.push(card9)
      }
      console.log(cardList)
      this.cardList = cardList

    },
    // 获取所有股票列表的近30天数据，并根据每天的涨幅生成cardlist
    async fetchAndGenerateCardList() {
      const codeArr = this.originCodeArr
      // 遍历codeArr，每个code都请求一次获取近30天涨幅，然后按天统计，生成cardlist

      // 获取traceDays天之前的日期
      const traceDaysArr = await this.getDateArr(this.traceDays)
      const startDate = traceDaysArr[traceDaysArr.length - 1]

      // 获取股票名称信息
      const codeTmpArr = []
      codeArr.forEach(element => {
        codeTmpArr.push(this.code2EastMoneyMarket(element) + element)
      });

      let stockInfoList
      if (codeTmpArr.length == codeArr.length) { //为了兼容个别停牌的情况：只有全部没有涨幅数据时，再获取
        const price_api = 'http://push2.eastmoney.com/api/qt/ulist.np/get?fltt=2&fields=f12,f14,f3,f22&secids=' + codeTmpArr.join(',')
        const resData = await this.$http.get(price_api);
        stockInfoList = resData.data.data.diff
      }

      // 遍历codeArr，获取历史涨幅数据
      const stockDataList = []
      for (let i = 0; i < codeArr.length; i++) {
        const code = codeArr[i]
        const url = this.apiUrl.akStockHist + code + '&start_date=' + startDate
        const res = await this.$http.get(url)
        const tmpArr = []
        res.data.forEach(item => {
          tmpArr.push(item['涨跌幅'])
        })

        const stockName = stockInfoList.find(item => item.f12 == code).f14
        const tmpObj = {
          code: code,
          name: stockName,
          markey: this.code2market(code),
          data: tmpArr
        }
        stockDataList.push(tmpObj)
      }

      // 遍历traceDaysArr，生成cardlist
      const cardList = []
      for (let i = 0; i < traceDaysArr.length; i++) {
        const date = traceDaysArr[i]
        
        const card0 = {
          width: 240,
          height: 480,
          xoffset: 0,
          yoffset: 500*i + 10,
          title: date,
          url: '/stock_rank_lxxd_ths',
          datalist_arr: [{ 'code': '300033', 'market': 'sz', '股票名称': '以岭药业', 'value': '9.8' }],
          fieldlist_arr: ['code', '股票名称']
        }
        const card1 = {
          width: 240,
          height: 480,
          xoffset: 250,
          yoffset: 500*i + 10,
          title: date,
          url: '/stock_rank_lxxd_ths',
          datalist_arr: [{ 'code': '300033', 'market': 'sz', '股票名称': '以岭药业', 'value': '9.8' }],
          fieldlist_arr: ['code', '股票名称']
        }
        const card2 = {
          width: 240,
          height: 480,
          xoffset: 500,
          yoffset: 500*i + 10,
          title: date,
          url: '/stock_rank_lxxd_ths',
          datalist_arr: [{ 'code': '300033', 'market': 'sz', '股票名称': '以岭药业', 'value': '9.8' }],
          fieldlist_arr: ['code', '股票名称']
        }
        const card3 = {
          width: 240,
          height: 480,
          xoffset: 750,
          yoffset: 500*i + 10,
          title: date,
          url: '/stock_rank_lxxd_ths',
          datalist_arr: [{ 'code': '300033', 'market': 'sz', '股票名称': '以岭药业', 'value': '9.8' }],
          fieldlist_arr: ['code', '股票名称']
        }
        const card4 = {
          width: 240,
          height: 480,
          xoffset: 1000,
          yoffset: 500*i + 10,
          title: date,
          url: '/stock_rank_lxxd_ths',
          datalist_arr: [{ 'code': '300033', 'market': 'sz', '股票名称': '以岭药业', 'value': '9.8' }],
          fieldlist_arr: ['code', '股票名称']
        }

        // 遍历stockDataList，根据当天涨幅，分到不同card中
        const tmpArr = [[], [], [], [], []]
        stockDataList.forEach(item => {
          const code = item.code
          const data = item.data
          const value = data[traceDaysArr.length - i - 1]
          
          if (value < -8) {
            tmpArr[0].push({ 'code': code, 'market': item.market, '股票名称': item.name, 'value': value })
          }else if (value < -3) {
            tmpArr[1].push({ 'code': code, 'market': item.market, '股票名称': item.name, 'value': value })
          }else if (value < 3) {
            tmpArr[2].push({ 'code': code, 'market': item.market, '股票名称': item.name, 'value': value })
          }else if (value < 8) {
            tmpArr[3].push({ 'code': code, 'market': item.market, '股票名称': item.name, 'value': value })
          }else {
            tmpArr[4].push({ 'code': code, 'market': item.market, '股票名称': item.name, 'value': value })
          }
        })

        card0.datalist_arr = tmpArr[0]
        card1.datalist_arr = tmpArr[1]
        card2.datalist_arr = tmpArr[2]
        card3.datalist_arr = tmpArr[3]
        card4.datalist_arr = tmpArr[4]
        
        cardList.push(card0)
        cardList.push(card1)
        cardList.push(card2)
        cardList.push(card3)
        cardList.push(card4)
      }
      console.log(cardList)
      this.cardList = cardList
    },
  },
  created() {
    console.log('Home created')

    // 判断页面类型，如果是limit_up就展示连板股票信息
    let isLimitUp = false
    if(this.$route.query){
      if(this.$route.query.type == 'limit_up'){
        this.fetchLimitUpCardList()
        isLimitUp = true
      }
    }

    // 如果不是limit_up，就从入参的codes参数中获取codeArr，然后生成cardList
    if(!isLimitUp){
      const codes = this.codes || '000001,399001,399006,000300,000016,000688'
      this.originCodeArr = codes.split(',')
      this.fetchAndGenerateCardList()
    }

    const that = this;
    document.onkeydown = function () {
      let key = window.event.keyCode;
      if (that.showChartDialog == true) {//只有查看k线图时，才执行
        if (key == 27) {//Esc键
          that.showChartDialog = false
        }
        if (key == 38) {//上键，显示上一个股票的K线和分时
          that.lastOne()
          window.event.stopPropagation()
          window.event.preventDefault()
        }
        if (key == 40) {//下键，显示下一个股票的K线和分时
          that.nextOne()
          window.event.stopPropagation()
          window.event.preventDefault()
        }
      }
      if (that.targetMoveCardIndex >= 0 && that.showMoveDialog == false && that.showChartDialog == false) {//只有存在目标card，且未显示移动对话框时，才执行
        if (key == 27) {//Esc键
          that.targetMoveCardIndex = -1
        }
        if (key == 37) {//左键
          that.move('xoffset', -250)
          window.event.stopPropagation()
          window.event.preventDefault()
        }
        if (key == 38) {//上键
          that.move('yoffset', -500)
          window.event.stopPropagation()
          window.event.preventDefault()
        }
        if (key == 39) {//右键
          that.move('xoffset', 250)
          window.event.stopPropagation()
          window.event.preventDefault()
        }
        if (key == 40) {//下键
          that.move('yoffset', 500)
          window.event.stopPropagation()
          window.event.preventDefault()
        }
      }
      if (that.selectedCode.length > 0 && that.showEditDialog == false) {//只有存在选中stock且不是“添加/删除股票”对话框状态时，才执行
        if (key == 27) {//Esc键
          that.selectedCode = ''
        }
        if (key == 36) {//Home键，置顶
          that.moveStock(-500)
          window.event.stopPropagation()
          window.event.preventDefault()
        }
        if (key == 33) {//PageUp键
          that.moveStock(-1)
          window.event.stopPropagation()
          window.event.preventDefault()
        }
        if (key == 35) {//End键，置底
          that.moveStock(500)
          window.event.stopPropagation()
          window.event.preventDefault()
        }
        if (key == 34) {//PageDown键
          that.moveStock(1)
          window.event.stopPropagation()
          window.event.preventDefault()
        }
        if (key == 46) {//PageDown键
          that.delStock()
          window.event.stopPropagation()
          window.event.preventDefault()
        }
      }
      if (key == 13 && that.showEditDialog) {//在编辑股票列表时按了回车键
        that.saveDatalist()
      }
    };

    // 阻止返回上一页，因为Macbook触摸板经常误触
    history.pushState(null, null, document.URL);
    window.addEventListener('popstate', function () {
      history.pushState(null, null, document.URL);
    });
  }
}
</script>

<style>
body {
  font-family: Arial, 黑体, sans-serif;
}

.title {
  font-size: 14px;
}

.text {
  font-size: 14px;
}

.item {
  margin-bottom: 4px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both
}

.box-card {
  position: absolute;
}

.card-content {
  max-height: 380px;
  overflow: hidden scroll;
}

.card-content::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 10px;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}

.card-content::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #535353;
}

.card-content::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  background: #ededed;
}

.btn-top {
  float: right;
  padding: 3px 1px;
  margin: 0;
}

.green {
  color: green;
}

.red {
  color: red;
}

.gray {
  color: gray;
}

.bold {
  font-weight: bold;
}

.red-border {
  border: solid 1px red;
}

.green-border {
  border: solid 1px green;
}

.bold-border {
  border-width: 2px;
}

.red-bg {
  background-color: red;
  color: #fff;
  font-weight: normal;
}

.green-bg {
  background-color: green;
  color: #fff;
  font-weight: normal;
}

@media screen and (min-width: 220px) and (max-width:600px) {
  .el-dialog{
    margin: 0 0 50px;
  }
}

</style>